import { AnnotationToolFeatureId, AnnotationToolSidebarAppID } from './annotationToolEnums';
import { UserRolesIdsEnum } from '../core/enums';

/**
 * Role mapping for annotation tool apps and routes.
 * This is the single source of truth for role-based access control.
 *
 * Both route protection and sidebar filtering should use this mapping.
 */

export const ANNOTATION_TOOL_ROLE_MAPPING: Record<string, UserRolesIdsEnum | UserRolesIdsEnum[]> = {
  [AnnotationToolSidebarAppID.annotationTool]: [
    UserRolesIdsEnum.ANNOTATION_MANAGER,
    UserRolesIdsEnum.ANNOTATION_USER,
  ],
  [AnnotationToolFeatureId.annotationDashboard]: [
    UserRolesIdsEnum.ANNOTATION_MANAGER,
    UserRolesIdsEnum.ANNOTATION_USER,
  ],
  [AnnotationToolFeatureId.annotationSupervisor]: [
    UserRolesIdsEnum.ANNOTATION_USER,
    UserRolesIdsEnum.ANNOTATION_MANAGER,
  ],
  [AnnotationToolFeatureId.annotation]: [UserRolesIdsEnum.ANNOTATION_USER],
  [AnnotationToolFeatureId.adminProjects]: [UserRolesIdsEnum.ANNOTATION_MANAGER],
  [AnnotationToolFeatureId.annotatorProjects]: [UserRolesIdsEnum.ANNOTATION_USER],
  [AnnotationToolFeatureId.supervisorProjects]: [UserRolesIdsEnum.ANNOTATION_USER],
  [AnnotationToolFeatureId.metrics]: [UserRolesIdsEnum.ANNOTATION_USER],
  [AnnotationToolFeatureId.metricsDashboard]: [UserRolesIdsEnum.ANNOTATION_USER],
  [AnnotationToolFeatureId.metricsSummary]: [UserRolesIdsEnum.ANNOTATION_USER],
  [AnnotationToolFeatureId.metricsEncounterStats]: [UserRolesIdsEnum.ANNOTATION_USER],
  [AnnotationToolFeatureId.metricsIRRScore]: [UserRolesIdsEnum.ANNOTATION_USER],
  [AnnotationToolFeatureId.metricsHolidays]: [UserRolesIdsEnum.ANNOTATION_USER],
};
